module.exports = __webpack_public_path__ + "img/driver.3e60b5c8.png";